import { render, staticRenderFns } from "./tentang.vue?vue&type=template&id=5c80e728&"
import script from "./tentang.vue?vue&type=script&lang=js&"
export * from "./tentang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports